export default __webpack_public_path__ + "static/media/antelope.ff60e443.webp";